var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('md-layout',{attrs:{"md-gutter":""}},[_c('md-layout',{attrs:{"md-row":"","md-gutter":"","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex":"80","md-align":"center"}},[_c('router-view',{attrs:{"id":"content"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-167e8842","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = +hHf
// module chunks = 1